'use client'
import {
  createIcon
} from "./chunk-DEQZ7DVA.mjs";
import {
  Icon
} from "./chunk-2GBDXOMA.mjs";
export {
  Icon,
  createIcon
};
//# sourceMappingURL=index.mjs.map